// extracted by mini-css-extract-plugin
export default {"payment_bill_detail_icon_button":"PaymentBillDetails_payment_bill_detail_icon_button__G8YFa","helper_for_service_code":"PaymentBillDetails_helper_for_service_code__Zj+F0"};